import { Platform } from 'react-native';

export const isWebBuild = () => Platform.OS === 'web';
